import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { Button } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type SsoProviderDeleteDialogProps = {
    isDeleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
    open: boolean;
    providerName: string | undefined;
};

export const SsoProviderDeleteDialog = ({
    isDeleting,
    onClose,
    onConfirm,
    open,
    providerName,
}: SsoProviderDeleteDialogProps) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("common.actions.confirmDelete", "Confirm deletion")}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t("settings.sso.providers.delete_confirm", 'Delete provider "{{name}}"? This cannot be undone.', {
                        name: providerName ?? "",
                    })}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="ternary" onClick={onClose} disabled={isDeleting}>
                    {t("common.actions.cancel", "Cancel")}
                </Button>
                <Button variant="delete" onClick={onConfirm} disabled={isDeleting}>
                    {t("common.actions.delete", "Delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
